import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import axios from "axios";
import { Formik } from "formik";
import { Typography } from "@mui/material";
import * as Yup from "yup";
import createInitialValue from "../../Utilities/InitialValuesSetup/createInitialValue";
import automaticValidationSchema from "../../Utilities/ValidationSchemaSetup/automaticValidationSchema";

import {
  createHDFCErgoFHSReqBdy,
  createHDFCErgoMHSReqBdy,
  createTabCareFreedomReqBdy,
  createTabCareReqBdy,
  createTabCareSeniorReqBdy,
  createTabStarReqBdy,
} from "../../Utilities/HealthInsuanceRequestBodies/CreateQuoteRequestBodis/careRequestBodiesCQ";
import {
  createHDFCErgoMedisureTopupFamilyReqBody,
  createHDFCErgoMedisureTopupIndividualReqBody,
} from "../../Utilities/HealthInsuanceRequestBodies/CreateQuoteRequestBodis/hdfcMedisureTopupCreateQuoteReqBody";
import {
  reInitialiseTabCareFreedomIntitialValues,
  reInitialiseTabCareIntitialValues,
  reInitialiseTabCareSeniorIntitialValues,
  reInitialiseTabStarInitialValues,
  reInitialiseTabHdfcInitialValues,
  reInitialiseHdfcMedisureTopupInitialValues,
  reInitialiseHdfcOptimaRestoreInitialValues,
} from "../../Utilities/HealthInsuanceRequestBodies/ReInitializeValues/reInitializeValues";
/* import CreateQuoteArray from './CreateQuoteDep&Obj/CreateQuoteArray';
import CreateQuoteMainObjectView from './CreateQuoteDep&Obj/CreateQuoteMainObjectView';
import ArrayMainComponent from './CreateQuoteDep&Obj/ArrayMainComponent'; */
import HealthInsuranceForm from "./HealthInsuranceForm";
import CryptoJS from "crypto-js";
import "../../Assets/css/policy.css";
import "../../Assets/css/globalStyle.css";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import { createHDFCErgoOptimaRestoreReqBody } from "../../Utilities/HealthInsuanceRequestBodies/CreateQuoteRequestBodis/hdfcOptimaRestoreCreateQuoteReqBody";
import { getLocalData } from "../../Utilities/Common/source";
import axiosInstance from "../../Utilities/djangoAxiosInstance";

//var serialize = require('form-serialize');

function Policy(props) {
  const Axios = axiosInstance
  const [disableBuy, setDisableBuy] = useState(false);
  const [productDetails, setProductDetails] = useState({});
  const [quickQuoteDetails, setQuickQuoteDetails] = useState({});
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [depInd, setdepInd] = useState(1);
  const { productId } = useParams();
  const localSource = getLocalData("source");
  console.log("Policy localSource: ", localSource);

  const steps = ["PRIMARY DETAILS", "PROPOSER DETAILS", "NOMINEE DETAILS"];

  const productIdArray = productId.split("*");
  const productRef = productIdArray[0];
  const responseId = productIdArray[1];
  const navigate = useNavigate();

  const productRefURI = decodeURIComponent(productRef).toString();
  const responseIdURI = decodeURIComponent(responseId).toString();

  const bytesProductRefURI = CryptoJS.AES.decrypt(
    productRefURI,
    "secret key @123"
  );
  const bytesResponseIdURI = CryptoJS.AES.decrypt(
    responseIdURI,
    "secret key @124"
  );

  const decryptedProductRef = JSON.parse(
    bytesProductRefURI.toString(CryptoJS.enc.Utf8)
  );
  const decryptedResponseId = JSON.parse(
    bytesResponseIdURI.toString(CryptoJS.enc.Utf8)
  );

  var initialValues;

  if (
    Object.keys(quickQuoteDetails).length > 0 &&
    Object.keys(productDetails).length > 0
  ) {
    //console.log("count....")
    initialValues = createInitialValue(productDetails);
    //console.log("initialValues", initialValues);

    /* initialValues.primaryDetail.map((field, ind) => { */
    Object.entries(initialValues).map((field, ind) => {
      if (field[0] === "primaryDetail") {
        initialValues.primaryDetail.map((innefield) => {
          for (let i = 0; i < depInd - 1; i++) {
            initialValues.primaryDetail.push(innefield);
          }
        });
      } else if (field[0] === "medicalQuestions") {
        initialValues.medicalQuestions.map((innefield) => {
          for (let i = 0; i < depInd - 1; i++) {
            initialValues.medicalQuestions.push(innefield);
          }
        });
      } /* else {

      /*  else if (field[0] === "dependentDetail") {
        initialValues.dependentDetail.map((innefield) => {
          for (let i = 0; i <=0; i++) {
            initialValues.dependentDetail.push(innefield);
          }
        });
      } */ /* else {
        initialValues.nomineeDetail.map((innefield) => {
          for (let i = 0; i <= 0; i++) {
            initialValues.nomineeDetail.push(innefield);
          }
        });
      } */
    });

    /*  }); */
    // console.log("updatedInitialValue", initialValues);
  }
  /* Reinitialze initial values  */
  if (
    Object.keys(quickQuoteDetails).length > 0 &&
    Object.keys(productDetails).length > 0
  ) {
    //console.log('prod na', productDetails.productName)
    if (productDetails.productName === "Tab_Care") {
      initialValues = reInitialiseTabCareIntitialValues(
        initialValues,
        quickQuoteDetails
      );
    } else if (productDetails.productName === "Tab_Senior") {
      initialValues = reInitialiseTabCareSeniorIntitialValues(
        initialValues,
        quickQuoteDetails
      );
    } else if (productDetails.productName === "Tab_CareFreedom") {
      initialValues = reInitialiseTabCareFreedomIntitialValues(
        initialValues,
        quickQuoteDetails
      );
    } else if (
      productDetails.productName === "POS Medi Classic Individual New Tab" ||
      productDetails.productName === "POS Family Health Optima New Tab"
    ) {
      initialValues = reInitialiseTabStarInitialValues(
        initialValues,
        quickQuoteDetails
      );
    } else if (productDetails.productName === "My Health Suraksha New Tab") {
      initialValues = reInitialiseTabHdfcInitialValues(
        initialValues,
        quickQuoteDetails
      );
      steps.pop();
    } else if (
      productDetails.productName === "Family Health Suraksha New Tab"
    ) {
      initialValues = reInitialiseTabHdfcInitialValues(
        initialValues,
        quickQuoteDetails
      );
      steps.pop();
    } else if (
      productDetails.productName === "Medisure Topup Individual" ||
      productDetails.productName === "Medisure Topup Family"
    ) {
      initialValues = reInitialiseHdfcMedisureTopupInitialValues(
        initialValues,
        quickQuoteDetails
      );
      steps.pop();
    } else if (productDetails.productName === "Optima Restore") {
      initialValues = reInitialiseHdfcOptimaRestoreInitialValues(
        initialValues,
        quickQuoteDetails
      );
      steps.splice(1, 0, "MEDICAL QUESTIONS");
    }
  }
  /* Reinitialze initial values  ends*/

  /*--------------------------------------------------*/

  var Fields = [];
  if (Object.keys(productDetails).length > 0) {
    productDetails.requestBody.formFields.fields.map((field, index) => {
      Fields.push(field);
    });
  }

  console.log("Fields", Fields);
  /*--------------------------------------------------*/
  var SchemaArray = [];

  if (Object.keys(productDetails).length > 0) {
    //console.log(productDetails,"productDetailsforError")
    productDetails.requestBody.formFields.fields.map((field, index) => {
      let seperatearray = [];

      seperatearray.push(field);

      SchemaArray.push(seperatearray);
    });
  }
  //console.log("SchemaArray", SchemaArray)
  /*--------------------------------------------------*/

  var validationSchema = Yup.object().shape({});
  if (Object.keys(productDetails).length > 0) {
    //console.log('premium', parseInt(quickQuoteDetails.premium))

    if (parseInt(quickQuoteDetails.premium) >= 50) {
      // console.log('premium inside', quickQuoteDetails.premium)
      //console.log('schhh', SchemaArray[activeStep])
      SchemaArray[activeStep].map((item) => {
        if (item.name === "primaryDetail") {
          //console.log('item', item)
          item.obj.map((innerField) => {
            if (innerField.name === "partyIdentityDOList") {
              innerField.obj.map((identityArrayEle) => {
                if (identityArrayEle.name === "panNumber") {
                  //          console.log('paan', identityArrayEle)
                  identityArrayEle.required = true;
                }
              });
            }
          });
        }

        if (item.name === "dependentDetail") {
          //console.log('item', item)
          item.obj.map((innerField) => {
            if (innerField.name === "partyIdentityDOList") {
              innerField.obj.map((identityArrayEle) => {
                if (identityArrayEle.name === "panNumber") {
                  console.log("paan", identityArrayEle);
                  identityArrayEle.required = true;
                }
              });
            }
            if (innerField.name === "spCode" && localSource != "b2c") {
              console.log("spCode", innerField);
              innerField.label = "POSP Code*";
              innerField.required = true;
            }
            if (innerField.name === "POSP_CODE" && localSource != "b2c") {
              console.log("Posp Code", innerField);
              innerField.label = "Posp Code*";
              innerField.required = true;
            }
          });
        }
      });
      //console.log('final', SchemaArray[activeStep])

      validationSchema = automaticValidationSchema(SchemaArray[activeStep]);
    } else {
      validationSchema = automaticValidationSchema(SchemaArray[activeStep]);
    }
  }
  //console.log('validation', validationSchema)
  /*--------------------------------------------------*/
  //const utility = "https://acuvisor.auxtomate.in/externalJS/manualValidation.js"

  useEffect(() => {
    let productDetailsArray = [];
    let domain = "";
     

    Axios.get(`product/${decryptedProductRef}`)
      .then((response) => {
        if (response.status === 200) {
          console.log("response node", response.data);
          //productDetailsArray.push(response.data)
          //setProductDetails(productDetailsArray);
          setProductDetails(response.data);
        }
      })
      .catch((e) => {
        alert(e);
      });

     

    Axios.get(`api/health/transfer-data/${decryptedResponseId}`, {
      params: {
        source: localSource,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log("response from djamgoo ", response);
          response.data.insureds.map((insure, insureIndex) => {
            localStorage.setItem(`date[${insureIndex}]`, `${insure.dob}`);
          });
          setQuickQuoteDetails(response.data);
          setdepInd(response.data.number_of_insured);
          // productDetailsArray.push(response.data)
          //setProductDetails(productDetailsArray);
          // setProductDetails(response.data);
        }
      })
      .catch((e) => {
        alert(e);
      });

    /* let utilityScript = document.createElement("script");
        utilityScript.src = utility;
        document.body.appendChild(utilityScript); */
    return () => {};
  }, []);

  const totalSteps = () => {
    return steps.length;
  };
  const handleBack = () => {
    if (activeStep !== 0) {
      window.scrollTo(0, 0);
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
      //formikContext.validateForm()
    } else {
      navigate(1);
    }
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    //setDisableBuy(true)
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  /*--------------------------------------------------*/

  const onSubmit = async (data, { resetForm }, actions) => {
    var FinalStarReq = {};
    let FinalCare;
    let FinalStarHealth;
    let careOvdKYC = false;
    let proposerNo = "";
    setDisableBuy(true);

    if (isLastStep()) {
      setDisableBuy(true);
      // console.log("submitted data", values);
      let domain = "";
      if (window.location.hostname === "localhost") {
        domain = process.env.REACT_APP_LOCAL_DJANGO;
      } else if (window.location.hostname.trim() === "acuvisor.com") {
        domain = process.env.REACT_APP_PRODUCTION_DJANGO;
      } else {
        domain = process.env.REACT_APP_UAT_DJANGO;
      }

      if (productDetails.productName === "Tab_Care") {
        FinalCare = createTabCareReqBdy(data);
        console.log("Tab_Care req bdy", FinalCare);

        FinalCare.intPolicyDataIO.policy.partyDOList.map((item) => {
          if (item.roleCd === "PROPOSER") {
            console.log("ovdkyc", item.ovdkyc);
            if (item.ovdkyc === "YES") {
              careOvdKYC = true;
              /* */
            }
          }
        });

        console.log("Tab_Care req bdy in JSON", JSON.stringify(FinalCare));

        let updatedData = {
          // "A_id":quickQuoteDetails.A_id,
          // "Acuvisor_product_id": quickQuoteDetails.Acuvisor_product_id,
          care: FinalCare,
        };

        if (careOvdKYC) {
          await Axios.post(
            `api/care/create-quote/${quickQuoteDetails.A_id}/${quickQuoteDetails.Acuvisor_product_id}/`,
            JSON.stringify(updatedData)
          )
            .then((response) => {
              if (response.data.details) {
                console.log("if part", response.data);
                alert(response.data.details + "\n" + response.data.message);
              } else {
                console.log("else part", response);
                if (response.data.message) {
                  setDisableBuy(false);
                  alert(response.data.message);
                } else {
                  proposerNo = response.data.proposalNum;
                  console.log("hha", proposerNo);
                  navigate(
                    `/health-insurance/kyc_document_upload/${response.data.id}`,
                    {
                      state: {
                        proposalNum: proposerNo,
                      },
                    }
                  );
                }
              }
            })
            .catch((errors) => {
              console.log(errors);
              alert(errors);
              setDisableBuy(false);

              //resetForm(formData = initialValues);
            });
        } else {
          await Axios.post(
            `api/care/create-quote/${quickQuoteDetails.A_id}/${quickQuoteDetails.Acuvisor_product_id}/`,
            JSON.stringify(updatedData),
            {
              params: {
                source: localSource,
              },
            }
          )
            .then((response) => {
              if (response.data.details) {
                console.log("if part", response.data);
                alert(response.data.details + "\n" + response.data.message);
              } else {
                console.log("else part", response);
                if (response.data.message) {
                  alert(
                    response.data.message.map((err) => {
                      return err.errDescription;
                    })
                  );
                  setDisableBuy(false);

                  //resetForm(formData= initialValues)
                } else {
                  // navigate(`/health-insurance/product-stastus/${response.data.id}`);
                  navigate(
                    `/health-insurance/product-stastus/${decryptedResponseId}`
                  );
                }
              }
            })
            .catch((errors) => {
              console.log(errors);
              alert(errors);
              resetForm(initialValues);
              setDisableBuy(false);
            });
        }
      } else if (productDetails.productName === "Tab_Senior") {
        console.log("action", actions);

        FinalCare = createTabCareSeniorReqBdy(
          data,
          productDetails.initialValues
        );
        console.log("Tab_Senior req bdy", FinalCare);
        console.log("Tab_Senior req bdy in JSON", JSON.stringify(FinalCare));

        let updatedData = {
          // "A_id":quickQuoteDetails.A_id,
          // "Acuvisor_product_id": quickQuoteDetails.Acuvisor_product_id,
          care: FinalCare,
        };

        await Axios.post(
          `api/care/create-quote/${quickQuoteDetails.A_id}/${quickQuoteDetails.Acuvisor_product_id}/`,
          JSON.stringify(updatedData)
        )
          .then((response) => {
            if (response.data.details) {
              console.log("if part", response.data);
              alert(response.data.details + "\n" + response.data.message);
            } else {
              console.log("else part", response);
              if (response.data.message) {
                setDisableBuy(false);

                alert(
                  response.data.message.map((err) => {
                    return err.errDescription;
                  })
                );
                //resetForm(formData= initialValues)
              } else {
                //navigate(`/health-insurance/product-stastus/${response.data.id}`);
                navigate(
                  `/health-insurance/product-stastus/${decryptedResponseId}`
                );
              }
            }
          })
          .catch((errors) => {
            console.log(errors);
            alert(errors);
            setDisableBuy(false);

            //resetForm(formData = initialValues);
          });
      } else if (productDetails.productName === "Tab_CareFreedom") {
        FinalCare = createTabCareFreedomReqBdy(data);
        console.log("Tab_CareFreedom req bdy", FinalCare);

        FinalCare.intPolicyDataIO.policy.partyDOList.map((item) => {
          if (item.roleCd === "PROPOSER") {
            console.log("ovdkyc", item.ovdkyc);
            if (item.ovdkyc === "YES") {
              careOvdKYC = true;
              /* */
            }
          }
        });
        console.log(
          "Tab_CareFreedom req bdy in JSON",
          JSON.stringify(FinalCare)
        );

        let updatedData = {
          // "A_id":quickQuoteDetails.A_id,
          // "Acuvisor_product_id": quickQuoteDetails.Acuvisor_product_id,
          care: FinalCare,
        };

        if (careOvdKYC) {
          await Axios.post(
            `api/care/create-quote/${quickQuoteDetails.A_id}/${quickQuoteDetails.Acuvisor_product_id}/`,
            JSON.stringify(updatedData)
          )
            .then((response) => {
              if (response.data.details) {
                console.log("if part", response.data);
                alert(response.data.details + "\n" + response.data.message);
              } else {
                console.log("else part", response);
                if (response.data.message) {
                  setDisableBuy(false);
                  alert(response.data.message);
                } else {
                  proposerNo = response.data.proposalNum;
                  console.log("hha", proposerNo);
                  navigate(
                    `/health-insurance/kyc_document_upload/${response.data.id}`,
                    {
                      state: {
                        proposalNum: proposerNo,
                      },
                    }
                  );
                }
              }
            })
            .catch((errors) => {
              console.log(errors);
              alert(errors);
              setDisableBuy(false);

              //resetForm(formData = initialValues);
            });
        } else {
          await Axios.post(
            `api/care/create-quote/${quickQuoteDetails.A_id}/${quickQuoteDetails.Acuvisor_product_id}/`,
            JSON.stringify(updatedData)
          )
            .then((response) => {
              if (response.data.details) {
                console.log("if part", response.data);
                alert(response.data.details + "\n" + response.data.message);
              } else {
                console.log("else part", response);
                if (response.data.message) {
                  setDisableBuy(false);
                  alert(response.data.message);
                } else {
                  //navigate(`/health-insurance/product-stastus/${response.data.id}`);
                  //navigate(`/health-insurance/product-stastus/${decryptedResponseId}`);
                  navigate(
                    `/health-insurance/product-stastus/${decryptedResponseId}`
                  );
                }
              }
            })
            .catch((errors) => {
              console.log(errors);
              alert(errors);
              setDisableBuy(false);

              //resetForm(formData = initialValues);
            });
        }
      } else if (
        productDetails.productName === "POS Medi Classic Individual New Tab" ||
        productDetails.productName === "POS Family Health Optima New Tab"
      ) {
        FinalStarHealth = createTabStarReqBdy(
          data,
          productDetails.initialValues
        );
        console.log(`${productDetails.productName}`, FinalStarHealth);
        console.log(
          `${productDetails.productName}`,
          JSON.stringify(FinalStarHealth)
        );

        let updatedData = {
          // "A_id":quickQuoteDetails.A_id,
          // "Acuvisor_product_id": quickQuoteDetails.Acuvisor_product_id,
          starHealth: FinalStarHealth,
        };

        await Axios.post(
          `api/health/create-quote/${quickQuoteDetails.A_id}/${quickQuoteDetails.Acuvisor_product_id}/`,
          JSON.stringify(updatedData)
        )
          .then((response) => {
            if (response.data.details) {
              console.log("if part", response.data);
              alert(response.data.details + "\n" + response.data.message);
              setDisableBuy(false);
            } else {
              console.log("else part", response);
              if (response.data.message) {
                /* alert(response.data.errorLists.map(err => {
                                        return err.errDescription
                                    })) */
                alert(response.data.message);
                //resetForm(formData= initialValues)
              } else {
                //navigate(`/health-insurance/product-stastus/${response.data.id}`);
                navigate(
                  `/health-insurance/product-stastus/${decryptedResponseId}`
                );
              }
            }
          })
          .catch((errors) => {
            console.log("SS", errors.response);
            setDisableBuy(false);

            alert(errors.response.data.message);
            //resetForm(formData = initialValues);
          });
      } else if (productDetails.productName === "My Health Suraksha New Tab") {
        // console.log("submit Data of Hdfc:",data)
        let finalHdfcReqBody = createHDFCErgoMHSReqBdy(
          data,
          productDetails.initialValues
        );
        console.log("Final Body :", finalHdfcReqBody);
        let updatedData = {
          hdfcErgoHealth: finalHdfcReqBody,
        };

        await Axios.post(
          `api/health/create-quote/${quickQuoteDetails.A_id}/${decryptedResponseId}/`,
          JSON.stringify(updatedData),
          {
            params: {
              source: localSource,
            }
          }
        )
          .then((response) => {
            if (response.data.details) {
              console.log("if part", response.data);
              alert(response.data.details + "\n" + response.data.message);
              setDisableBuy(false);
            } else {
              console.log("else part", response);
              if (response.data.message) {
                /* alert(response.data.errorLists.map(err => {
                                        return err.errDescription
                                    })) */
                alert(response.data.message);
                //resetForm(formData= initialValues)
              } else {
                navigate(
                  `/health-insurance/hdfc-ergo-product-status/${response.data.id}`
                );
              }
            }
          })
          .catch((errors) => {
            console.log("SS", errors.response);
            setDisableBuy(false);

            alert(errors.response.statusText);
            //resetForm(formData = initialValues);
          });
      } else if (
        productDetails.productName === "Family Health Suraksha New Tab"
      ) {
        // console.log("submit Data of Hdfc:",data)
        let finalHdfcReqBody = createHDFCErgoFHSReqBdy(
          data,
          productDetails.initialValues
        );
        console.log("Final Body :", finalHdfcReqBody);
        let updatedData = {
          hdfcErgoHealth: finalHdfcReqBody,
        };

        await Axios.post(
          `api/health/create-quote/${quickQuoteDetails.A_id}/${decryptedResponseId}/`,
          JSON.stringify(updatedData),
          {
            params: {
              source: localSource,
            }
          }
        )
          .then((response) => {
            if (response.data.details) {
              console.log("if part", response.data);
              alert(response.data.details + "\n" + response.data.message);
              setDisableBuy(false);
            } else {
              console.log("else part", response);
              if (response.data.message) {
                /* alert(response.data.errorLists.map(err => {
                                        return err.errDescription
                                    })) */
                alert(response.data.message);
                //resetForm(formData= initialValues)
              } else {
                navigate(
                  `/health-insurance/hdfc-ergo-product-status/${response.data.id}`
                );
              }
            }
          })
          .catch((errors) => {
            console.log("SS", errors.response);
            setDisableBuy(false);

            alert(errors.response.statusText);
            //resetForm(formData = initialValues);
          });
      } else if (
        productDetails.productName === "Medisure Topup Individual" ||
        productDetails.productName === "Medisure Topup Family"
      ) {
        console.log("submit Data of Medisure Topup Individual:", data);
        let hdfcMedisureTopupReqBody =
          productDetails.productName === "Medisure Topup Individual"
            ? createHDFCErgoMedisureTopupIndividualReqBody(
                data,
                productDetails.initialValues
              )
            : createHDFCErgoMedisureTopupFamilyReqBody(
                data,
                productDetails.initialValues
              );
        console.log(
          "Final hdfcMedisureTopupIndividualReqBody :",
          hdfcMedisureTopupReqBody
        );
        let updatedData = {
          hdfcMedisureTopup: hdfcMedisureTopupReqBody,
        };

        await Axios.post(
          `api/health/create-quote/${quickQuoteDetails.A_id}/${decryptedResponseId}/`,
          JSON.stringify(updatedData),
          {
            params: {
              source: localSource,
            }
          }
        )
          .then((response) => {
            console.log("hdfcMedisureTopup response", response.data);
            if (response.data.details) {
              console.log("if part", response.data);
              alert(response.data.details + "\n" + response.data.message);
              setDisableBuy(false);
            } else {
              // console.log('else part', response)
              if (response.data.message) {
                /* alert(response.data.errorLists.map(err => {
                                        return err.errDescription
                                    })) */
                alert(response.data.message);
                //resetForm(formData= initialValues)
              } else {
                navigate(
                  `/health-insurance/hdfc-ergo-product-status/${response.data.id}`
                );
              }
            }
          })
          .catch((errors) => {
            console.log("SS", errors.response);
            setDisableBuy(false);

            alert(errors.response.statusText);
            //resetForm(formData = initialValues);
          });
      } else if (productDetails.productName === "Optima Restore") {
        console.log("Submit Data of Optima Restore:", data);
        let hdfcOptimaRestoreReqBody = createHDFCErgoOptimaRestoreReqBody(
          data,
          productDetails.initialValues,
          quickQuoteDetails
        );
        console.log(
          "Final hdfcOptimaRestoreReqBody :",
          hdfcOptimaRestoreReqBody
        );
        let updatedData = {
          hdfcOptimaRestoreReqBody: hdfcOptimaRestoreReqBody,
        };
        console.log("decrypted response id", decryptedResponseId);
        await Axios.post(
          `api/health/create-quote/${quickQuoteDetails.A_id}/${decryptedResponseId}/`,
          JSON.stringify(updatedData),
          {
            params: {
              source: localSource,
            }
          }
        )
          .then((response) => {
            console.log("hdfcOptimaRestoreReqBody response", response.data);
            if (response.data.details) {
              console.log("if part", response.data);
              alert(response.data.details + "\n" + response.data.message);
              setDisableBuy(false);
            } else {
              // console.log('else part', response)
              if (response.data.message) {
                /* alert(response.data.errorLists.map(err => {
                                        return err.errDescription
                                    })) */
                alert(response.data.message);
                //resetForm(formData= initialValues)
              } else if (
                hdfcOptimaRestoreReqBody.memberDetailsList[0].hdcCheck ===
                  "true" ||
                hdfcOptimaRestoreReqBody.memberDetailsList[0].ipaRiderCheck ===
                  "true" ||
                hdfcOptimaRestoreReqBody.memberDetailsList[0].pCheck ===
                  "true" ||
                hdfcOptimaRestoreReqBody.memberDetailsList[0]
                  .unlimitedRiderCheck === "true"
              ) {
                console.log("revised");
                Swal.fire({
                  icon: "warning",
                  // title: `${response.data.data.iskycVerified}`,
                  title: "Your premium changed",
                  //   text: "Click on OK button to proceed",
                  text: `Premium has changed due to the selection of riders, 
                                      Your revised premium: ${response.data.revisedPremium}`,
                  position: "center",

                  showClass: {
                    popup: "animate__animated animate__fadeInDown",
                  },
                  hideClass: {
                    popup: "animate__animated animate__fadeOutUp",
                  },
                }).then((result) => {
                  if (result.isConfirmed) {
                    navigate(
                      `/health-insurance/product-stastus/${decryptedResponseId}`
                    );
                  }
                });
              } else {
                navigate(
                  `/health-insurance/product-stastus/${decryptedResponseId}`
                );
                // navigate(`/health-insurance/hdfc-ergo-product-status/${response.data.id}`);
              }
            }
          })
          .catch((errors) => {
            console.log("SS", errors.response);
            setDisableBuy(false);
            alert("Something went wrong, try again..");
            // alert(errors.response.statusText)
            //resetForm(formData = initialValues);
          });
      }

      /* else {
              Object.entries(data).map((field, index) => {
                switch (field[0]) {
                  case "primaryDetail":
                    field[1].map((nestedField, ind) => {
                      FinalStarReq = { ...FinalStarReq, ...nestedField };
                    });
      
                    break;
                  case "dependentDetail":
                    const dependentObj = {};
                    field[1].map((nestedField, ind) => {
                      dependentObj[`insureds[${ind}]`] = nestedField;
                    });
                    FinalStarReq = { ...FinalStarReq, ...dependentObj };
                    break;
                  case "nomineeDetail":
                    field[1].map((nestedField, ind) => {
                      FinalStarReq = { ...FinalStarReq, ...nestedField };
                    });
                    break;
                }
              });
            } */

      //console.log("FinalCare", FinalCare);

      //////     console.log("StarReq3", FinalStarReq);

      if (
        productDetails.productName === "Tab_Care" ||
        productDetails.productName === "Tab_Senior" ||
        productDetails.productName === "Tab_CareFreedom"
      ) {
      }
    } else {
      setDisableBuy(false);
      window.scrollTo(0, 0);
      setActiveStep(activeStep + 1);
      //actions.setTouched({});
      //actions.setSubmitting(false);
    }
    // const newActiveStep =
    //   isLastStep() && !allStepsCompleted()
    //     ? steps.findIndex((step, i) => !(i in completed))
    //     : activeStep + 1;
    // setActiveStep(newActiveStep);
  };

  return (
    <div>
      <div className="">
        <div className="">
          <CategoryHeader title="Health Insurance" />
          <div className=" ">
            <h3 className="fw-700 text-center my-4 heading-text text-capitalize">
              PROPOSAL FORM
            </h3>
            <div className="mx-auto stepper-container text-wraper">
              <div className="mx-auto stepper-container">
                <div className="Stepper_container">
                  <div className="steppers">
                    {steps.map((field, index) => {
                      return (
                        <div
                          className={
                            activeStep === index ? "active" : `step${index}`
                          }
                          onClick={() => {
                            if (index < activeStep) setActiveStep(index);
                          }}
                          key={index}
                        >
                          <p
                            className={
                              activeStep === index ? "active_text" : "text"
                            }
                          >
                            {field}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <p className="stepper"></p>
              </div>
            </div>

            <div>
              {initialValues ? (
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  enableReinitialize={false}
                  onSubmit={onSubmit}
                >
                  {(formik) => {
                    console.log("formik val", formik);
                    var newTouch = {};
                    /*  if (
                                           formik.isSubmitting && Object.keys(formik.touched).length > 0 &&
                                           (formik.touched.primaryDetail.length < 2 || formik.touched.dependentDetail.length < 2 || formik.touched.nomineeDetail.length < 2)
                                         ) */
                    /*  {
                                           Object.entries(formik.touched).map((field, ind) => {
                                             if (field[0] === "primaryDetail") {
                                               formik.touched.primaryDetail.map((innefield) => {
                                                 for (let i = 0; i < 2; i++) {
                                                   formik.touched.primaryDetail.push(innefield);
                                                 }
                                               });
                                             } else if (field[0] === "dependentDetail") {
                                               formik.touched.dependentDetail.map((innefield) => {
                                                 for (let i = 0; i < 2; i++) {
                                                   formik.touched.dependentDetail.push(innefield);
                                                 }
                                               });
                                             } else {
                                               formik.touched.nomineeDetail.map((innefield) => {
                                                 for (let i = 0; i < 2; i++) {
                                                   formik.touched.nomineeDetail.push(innefield);
                                                 }
                                               });
                                             }
                                           });
                                         } */

                    return (
                      <HealthInsuranceForm
                        Fields={Fields}
                        activeStep={activeStep}
                        quickQuoteDetails={quickQuoteDetails}
                        depInd={depInd}
                        productName={productDetails.productName}
                        disableBuy={disableBuy}
                        handleBack={handleBack}
                        isLastStep={isLastStep}
                      />
                    );
                  }}
                </Formik>
              ) : (
                <Typography>Loading....</Typography>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Policy;
